export default __webpack_public_path__ + "static/media/PornBest.01e2dccc.png";